/**
 * Checks if the current district has a specific setting enabled.
 * @param {Object} store - The Vuex store instance.
 * @param {String} key - The settings key to check for.
 * @param {String|Number} [expectedValue] - Optional. The value to match (e.g., '1' for enabled).
 * @returns {Boolean} True if the setting exists (and matches expectedValue if provided), false otherwise.
 */
export function hasDistrictSetting(store, key, expectedValue) {
  const districtSettings = store.getters['appConfig/getDistrictSettings'] || []
  const districtSetting = Array.isArray(districtSettings)
    ? districtSettings.find(item => item.key === key)
    : null

  if (expectedValue !== undefined) {
    return !!districtSetting && districtSetting.value === expectedValue
  }
  return !!districtSetting
}

/**
 * Checks if the current school has a specific setting enabled.
 * @param {Object} store - The Vuex store instance.
 * @param {String} key - The settings key to check for.
 * @param {String|Number} [expectedValue] - Optional. The value to match (e.g., '1' for enabled).
 * @returns {Boolean} True if the setting exists (and matches expectedValue if provided), false otherwise.
 */
export function hasSchoolSetting(store, key, expectedValue) {
  const schoolSettings = store.getters['appConfig/getSchoolSettings'] || []
  const schoolSetting = Array.isArray(schoolSettings)
    ? schoolSettings.find(item => item.key === key)
    : null

  if (expectedValue !== undefined) {
    return !!schoolSetting && schoolSetting.value === expectedValue
  }
  return !!schoolSetting
}
